import { memo } from 'react';
import { OlyCell, OlySym } from '@raketta/shared';

// Оригинальные SVG-символы (нарисованы для проекта).
const GEM: Record<string, string> = { l1: '#ff4d5e', l2: '#b06bff', l3: '#ffcf33', l4: '#42d17a', l5: '#36b9ff' };

function glyph(s: OlySym, m?: number) {
  if (s === 'mult')
    return (
      <g>
        <circle cx="32" cy="32" r="22" fill="#7a4dff" stroke="#ffd24a" strokeWidth="3" />
        <circle cx="26" cy="25" r="9" fill="#fff" opacity="0.25" />
        <text x="32" y="40" textAnchor="middle" fontSize="19" fontWeight="800" fill="#fff">
          {m ? `${m}×` : '×'}
        </text>
      </g>
    );
  if (s === 'scatter')
    return (
      <g>
        <circle cx="32" cy="32" r="22" fill="#0e2233" stroke="#ffd24a" strokeWidth="2.5" />
        <path d="M36 14L22 36h9l-3 16 16-24h-9z" fill="#ffd24a" />
      </g>
    );
  if (s === 'h1') // корона
    return (
      <g fill="#ffcf33" stroke="#b8860b" strokeWidth="1.5">
        <path d="M14 44l-2-22 12 10 8-16 8 16 12-10-2 22z" />
        <rect x="14" y="44" width="36" height="6" />
      </g>
    );
  if (s === 'h2') // песочные часы
    return (
      <g>
        <path d="M18 14h28l-14 18zM18 50h28l-14-18z" fill="#caa14a" />
        <rect x="16" y="12" width="32" height="4" fill="#7a5a1a" />
        <rect x="16" y="48" width="32" height="4" fill="#7a5a1a" />
      </g>
    );
  if (s === 'h3') // кольцо с камнем
    return (
      <g>
        <circle cx="32" cy="38" r="14" fill="none" stroke="#ffcf33" strokeWidth="5" />
        <path d="M32 10l8 10H24z" fill="#ff4d5e" />
      </g>
    );
  if (s === 'h4') // кубок
    return (
      <g fill="#ffcf33">
        <path d="M18 14h28c0 14-6 20-14 20S18 28 18 14z" />
        <rect x="30" y="34" width="4" height="12" />
        <rect x="22" y="46" width="20" height="5" />
      </g>
    );
  // самоцветы l1..l5 — ромбы
  const col = GEM[s] || '#888';
  return (
    <g>
      <path d="M32 12l16 14-16 26-16-26z" fill={col} />
      <path d="M32 12l16 14-16 8-16-8z" fill="#fff" opacity="0.25" />
    </g>
  );
}

export const OlympusSymbol = memo(
  function OlympusSymbol({ cell, size = 48 }: { cell: OlyCell; size?: number }) {
    return (
      <svg viewBox="0 0 64 64" width={size} height={size} className={`oly-sym oly-${cell.s}`}>
        {glyph(cell.s, cell.m)}
      </svg>
    );
  },
  (a, b) => a.cell.s === b.cell.s && a.cell.m === b.cell.m && a.size === b.size
);
